import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface webSocketManager {
  response: string
  isGeneratingResponse: boolean
  botResponse: any | null
  userLastMessageText: string
  isSocketConnected: boolean
  messageSendingInProgress: boolean
  isSocketFallbackTriggered: boolean
  voiceToTextService: string
  interruptTriggered: boolean
  canInterruptMessage: boolean
  lastSentMessageTimestamp: number | null
  isPhaseTransition: boolean
  phaseTransitionTimeout: number
}

const initialState: webSocketManager = {
  response: "",
  isGeneratingResponse: false,
  botResponse: null,
  userLastMessageText: "",
  isSocketConnected: false,
  messageSendingInProgress: false,
  isSocketFallbackTriggered: false,
  voiceToTextService: "deepgram",
  interruptTriggered: false,
  canInterruptMessage: false,
  lastSentMessageTimestamp: null,
  isPhaseTransition: false,
  phaseTransitionTimeout: 60000, // 60 seconds for phase transitions
}

const webSocketManagerSlice = createSlice({
  name: "web-socket-manager",
  initialState: initialState,
  reducers: {
    appendSocketResponseChunk: (state, action) => ({
      ...state,
      response: state.response + " " + action.payload,
    }),
    setClearResponse: (state) => ({
      ...state,
      response: "",
    }),
    setIsGeneratingResponse: (state, action) => {
      state.isGeneratingResponse = action.payload
    },
    setBotResponse: (state, action) => {
      state.botResponse = action.payload
    },
    setUserLastMessageText: (state, action: PayloadAction<string>) => {
      state.userLastMessageText = action.payload
    },
    setIsSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.isSocketConnected = action.payload
    },
    setMessageSendingInProgress: (state, action: PayloadAction<boolean>) => {
      state.messageSendingInProgress = action.payload
    },
    setIsSocketFallbackTriggered: (state, action: PayloadAction<boolean>) => {
      state.isSocketFallbackTriggered = action.payload
    },
    resetBotResponse: (state) => ({
      ...state,
      botResponse: null,
      response: "",
    }),
    setVoiceToTextService: (state, action: PayloadAction<string>) => {
      state.voiceToTextService = action.payload
    },
    setInterruptTriggered: (state, action: PayloadAction<boolean>) => {
      state.interruptTriggered = action.payload
    },
    setCanInterruptMessage: (state, action: PayloadAction<boolean>) => {
      state.canInterruptMessage = action.payload
    },
    setLastSentMessageTimestamp: (state, action: PayloadAction<number | null>) => {
      state.lastSentMessageTimestamp = action.payload
    },
    setIsPhaseTransition: (state, action: PayloadAction<boolean>) => {
      state.isPhaseTransition = action.payload
    },
    setPhaseTransitionTimeout: (state, action: PayloadAction<number>) => {
      state.phaseTransitionTimeout = action.payload
    },
  },
})

export const {
  appendSocketResponseChunk,
  setClearResponse,
  setIsGeneratingResponse,
  setBotResponse,
  setUserLastMessageText,
  setIsSocketConnected,
  setMessageSendingInProgress,
  setIsSocketFallbackTriggered,
  resetBotResponse,
  setVoiceToTextService,
  setInterruptTriggered,
  setLastSentMessageTimestamp,
  setCanInterruptMessage,
  setIsPhaseTransition,
  setPhaseTransitionTimeout,
} = webSocketManagerSlice.actions

export default webSocketManagerSlice.reducer
